import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="relative z-10 border-t border-[#C7CCC5] bg-[#E6EAE4] text-[#1E1E1E]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 py-20 md:px-10">
        <div className="grid gap-14 md:grid-cols-12">
          <div className="md:col-span-6">
            <p className="font-syne text-3xl font-extrabold uppercase leading-tight tracking-tight md:text-4xl">
              Get dressed.
              <br />
              <span className="sage-text">Go make a scene.</span>
            </p>
            <p className="mt-6 max-w-sm text-sm font-light leading-relaxed text-[#5C5C5C]">
              Small drops, strong silhouettes, and clothes worth leaving the house for.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="mb-5 font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#777]">Navigate</p>
            <ul className="space-y-3 text-sm text-[#454545]">
              <li><Link data-testid="footer-shop-link" to="/shop" className="transition-colors hover:text-[#657260]">Shop</Link></li>
              <li><Link data-testid="footer-collections-link" to="/shop#collections" className="transition-colors hover:text-[#657260]">Collections</Link></li>
              <li><Link data-testid="footer-looks-link" to="/looks" className="transition-colors hover:text-[#657260]">Lookbook</Link></li>
              <li><Link data-testid="footer-story-link" to="/story" className="transition-colors hover:text-[#657260]">Our Story</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="mb-5 font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#777]">Drop notes</p>
            <p className="text-sm leading-relaxed text-[#5C5C5C]">New pieces land in small runs. If you see your size, do not overthink it.</p>
            <p className="mt-4 font-mono2 text-[9px] font-bold uppercase tracking-[0.18em] text-[#657260]" data-testid="footer-shipping-note">Shipping exclusively to Canada &amp; US</p>
            <Link to="/shop" data-testid="footer-latest-drop-link" className="mt-5 inline-flex items-center gap-2 border-b border-[#657260] pb-1 font-mono2 text-[10px] font-bold uppercase tracking-[0.2em] text-[#657260]">
              Shop latest drop <ArrowUpRight size={12} />
            </Link>
          </div>
        </div>
      </div>
      <div className="overflow-hidden border-t border-[#CDD2CB] px-2 pb-4">
        <p className="text-outline whitespace-nowrap text-center font-syne text-[13.5vw] font-extrabold uppercase leading-none opacity-40">
          Aura Studio 98
        </p>
        <p className="mt-4 text-center font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#777]">
          © 2026 Aura Studio 98 — All frequencies reserved
        </p>
      </div>
    </footer>
  );
}
